import { Box } from "@mui/material";
import React from "react";

const CssSpinner = ({ size = "6em" }) => {
  return <Box className="loader" sx={{'&:after':{width:size, height:size}}} style={{ width: size, height: size,}}></Box>;
};

export default CssSpinner;
